import humanizeDuration, { HumanizerOptions } from 'humanize-duration'

export enum DURATION_LANGUAGE {
  SHORT_EN = 'shortEn',
  SHORT_EN_UPPER_CASE = 'shortEnUpperCase',
  SHORT_EN_EXTENDED = 'shortEnExtended'
}

export const displayDuration = ({ time, options }: { time: number; options?: HumanizerOptions }): string => {
  const humanizer = humanizeDuration.humanizer({
    units: ['d', 'h', 'm'],
    maxDecimalPoints: 0,
    spacer: '',
    delimiter: ' ',
    largest: 3,
    language: DURATION_LANGUAGE.SHORT_EN,
    languages: {
      [DURATION_LANGUAGE.SHORT_EN]: {
        y: () => 'y',
        mo: () => 'mo',
        w: () => 'w',
        d: () => 'd',
        h: () => 'h',
        m: () => 'm',
        s: () => 's',
        ms: () => 'ms'
      },
      [DURATION_LANGUAGE.SHORT_EN_UPPER_CASE]: {
        y: () => 'Y',
        mo: () => 'MO',
        w: () => 'W',
        d: () => 'D',
        h: () => 'H',
        m: () => 'M',
        s: () => 'S',
        ms: () => 'MS'
      },
      [DURATION_LANGUAGE.SHORT_EN_EXTENDED]: {
        y: () => 'y',
        mo: () => 'mo',
        w: () => 'w',
        d: () => 'd',
        h: () => 'h',
        m: () => 'min',
        s: () => 's',
        ms: () => 'ms'
      }
    }
  })

  if (options) {
    Object.entries(options).forEach(([key, value]) => {
      humanizer[key] = value
    })
  }
  return humanizer(time)
}
